import { render, staticRenderFns } from "./ViewCollection.vue?vue&type=template&id=7f52f5c2&scoped=true&"
import script from "./ViewCollection.vue?vue&type=script&lang=js&"
export * from "./ViewCollection.vue?vue&type=script&lang=js&"
import style0 from "./ViewCollection.vue?vue&type=style&index=0&id=7f52f5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52f5c2",
  null
  
)

export default component.exports